<template lang="pug">
    .page
        .banner
            p 龙腾资本（Dragonrise Capital）是一家管理着数支美元和人民币基金专业风险投资机构
            p 重点关注投资TMT和移动互联网领域的优质创业项目，希望与创业者携手共创未来！
        .content-container
            .item(v-for="(item, index) in list", @click="handleShow(item)" :key="index")
                img.logo(:src="item.thumbnail")
                .name {{item.title}}
        .dialog(v-show="showDialog", @click="showDialog = false")
            .dialog-main
                .close
                .dialog-content
                    img(:src="detail.thumbnail")
                    .info
                        .name {{detail.title}}
                        .content(v-html="detail.content")
  </template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            showDialog: false,
            detail: {},
            list: []
        }
    },
    methods: {
        onGetData() {
            axios.get('/api/case').then(res => {
                this.list = res.data.items
            })
        },
        handleShow(_item) {
            this.detail = _item
            this.showDialog = true
        }
    },
    created() {
        this.onGetData()
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    .dialog
        position: fixed
        height: 100vh
        width: 100%
        left: 0
        top: 0
        background: rgba(0, 0, 0, 0.9)
        display: flex
        align-items: center
        justify-content: center
        .dialog-main
            background: #fff
            width: 80%
            box-sizing: border-box
            padding: 2%
            max-height: 60vh
            overflow-y: scroll
            .close
            .dialog-content
                img
                    width: 100%
                    display: block
                .info
                    .name
                    .office
                    .content
                        font-size: 12px
    .banner
        width: 100%
        background: #f9f9f9
        padding: 100px 60px
        text-align: center
        line-height: 2
        box-sizing: border-box
    .content-container
        max-width: 1000px
        margin: 0 auto
        padding-top: 60px
        display: flex
        flex-wrap: wrap
        .item
            width: calc(50% - 20px)
            margin: 10px
            cursor: pointer
            .logo
                display: block
                width: 100%
            .name
                text-align: center
                font-size: 14px
                padding: 1em 0
@media screen and (min-width: 1024px)
    .page
        width: 100%
        .dialog
            position: fixed
            height: 100vh
            width: 100%
            left: 0
            top: 0
            background: rgba(0, 0, 0, 0.3)
            display: flex
            align-items: center
            justify-content: center
            .dialog-main
                background: #fff
                width: 900px
                box-sizing: border-box
                padding: 20px
                max-height: unset;
                overflow-y: unset
                .close
                .dialog-content
                    display: flex
                    align-items: flex-start
                    line-height: 2
                    img
                        width: 400px
                        display: block
                    .info
                        padding: 0 20px
                        box-sizing: border-box
                        max-height: 500px
                        overflow-y: scroll
                        .name
                            font-size: 18px
                        .office
                            font-size: 14px
                        .content
                            font-size: 14px
                            p
                                margin: 35px auto
        .banner
            width: 100%
            background: #f9f9f9
            padding: 160px 0 100px 0
            text-align: center
            line-height: 2
        .content-container
            max-width: 1000px
            margin: 0 auto
            padding-top: 60px
            display: flex
            flex-wrap: wrap
            .item
                margin: 0
                margin-bottom: 50px
                width: 20%
                cursor: pointer
                .logo
                    display: block
                    width: 100%
                .name
                    text-align: center
                    font-size: 14px
                    padding: 1em 0
</style>